class UnimicroAuthController extends AbstractIntegrationController
	@register()
	@inject '$stateParams',
		'IntegrationRepository'

	integrationId: 'unimicro'

	initialize: ->
		if @$stateParams.error
			@goToConfigPage()

			return

		@IntegrationRepository
			.customPost @integrationId, 'connect', {code: @$stateParams.code}
			.then =>
				@goToConfigPage()
			.catch (response) =>
				@handleErrors(response)
				@goToConfigPage()
